import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import {
  EmptyMedicationRequestCard,
  MedicationRequestCard,
} from "@/features/my-meds/components";
import { useCurrentMedicationRequests } from "@/features/my-meds/hooks";
import { Card, CardSkeleton, PillIcon } from "@/shared/ui";

export const CurrentMedicationRequests = () => {
  const {
    data: currentRequests,
    isLoading,
    isSuccess,
  } = useCurrentMedicationRequests();

  return (
    <Card.Root className="flex-1">
      <Card.Header className="flex-col">
        <Card.Title icon={PillIcon}>{t`Medication refill requests`}</Card.Title>

        <Link
          to={ROUTES.MY_MEDS}
          className="hidden w-fit font-medium text-primary-950 hover:underline md:block"
        >
          {t`View all requests`}
        </Link>
      </Card.Header>

      <Card.Content className="flex flex-col gap-3">
        {isLoading && <CardSkeleton className="px-2" />}

        {isSuccess && (
          <div className="flex flex-col gap-3">
            {currentRequests.length ? (
              currentRequests.map((request) => (
                <MedicationRequestCard
                  key={request.subscription.id}
                  medicationRequest={request}
                />
              ))
            ) : (
              <EmptyMedicationRequestCard />
            )}
          </div>
        )}

        <div className="flex w-full items-center justify-center pb-2 md:hidden">
          <Link
            to={ROUTES.MY_MEDS}
            className="w-fit font-medium text-primary-950 hover:underline"
          >
            {t`View all requests`}
          </Link>
        </div>
      </Card.Content>
    </Card.Root>
  );
};
